import AbstractWidget from "@/models/WebsiteWidget/AbstractWidget";
import WebsiteWidget from "@/models/WebsiteWidget/WebsiteWidget";
import Photo from "@/models/WebsiteWidget/Gallery/Photo/Photo";
import {sortBy} from "lodash";


export default class Gallery extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/gallery';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetGalleries';

    /**
     * Relations used for normalization
     * @returns {{}}
     */

    static fields() {
        return {
            id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            widget: this.hasOne(WebsiteWidget, 'widgetable_id'),
            photos: this.hasMany(Photo, 'website_widget_gallery_id'),
        }
    }

    /**
     *
     * @constructor
     */
    Photos() {
        return sortBy(Photo.byWebsiteGallery(this.id), ['rank']);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        if(!this.WidgetTemplate()){
            return null;
        }
        return WebsiteWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }

}
